module.exports = __webpack_public_path__ + "7bb7212c0fb80b831e9166a27c455d71.svg";